import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRoot } from 'react-dom/client';

import { App } from './app/App.js';
import { AppStateProvider } from './app/AppState.js';

const rootElement = document.getElementById('app');

if (!rootElement) {
  throw new Error('Missing #app root element');
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(rootElement).render(
  <QueryClientProvider client={queryClient}>
    <AppStateProvider>
      <App />
    </AppStateProvider>
  </QueryClientProvider>,
);
